module.exports = __webpack_public_path__ + "img/Ambulancier7.9d97a754.jpg";